import { whiteColor, rowHoverColor, grayColor, borderColor } from 'assets/jss/material-dashboard-pro-react';
const selectPlanDialogStyle = (theme) => ({
	requiredTitle: {
		marginTop: '20px',
	},
	colorWhite: {
		color: `${whiteColor} !important`,
	},
	requiredServiceWrapper: {
		display: 'flex',
		[theme.breakpoints.down('xs')]: {
			display: 'inline-block',
		},
	},
	requiredServiceMainWrapper: {
		marginBottom: '20px',
	},

	staticIpOptionsWrapper: {
		display: 'flex',
		marginTop: '20px',
	},
	staticIpHeadingWrapper: {
		width: '100%',
	},
	staticIpGroup: {
		display: 'flex',
	},
	staticIpWrapper: {
		display: 'flex',
		flexDirection: 'column',
		marginTop: '20px',
		marginBottom: '10px',
	},
	staticIpCheckboxWrapper: {
		display: 'flex',
		alignItems: 'end',
	},
	staticIpOptionsModes: {
		display: 'flex',
		justifyContent: 'flex-start',
		width: '40%',
		padding: '10px',
		marginLeft: '40px',
		border: `1px solid ${borderColor}`,
		borderRadius: '5px',
	},
	staticIpOptionsConfigs: {
		display: 'flex',
		justifyContent: 'flex-start',
		width: '40%',
		padding: '10px',
		border: `1px solid ${borderColor}`,
		borderRadius: '5px',
	},
	additionalServiceCell: {
		width: '46%',
		paddingLeft: 16,
	},
	header: {
		marginTop: '2%',
		marginLeft: '5%',
		display: 'inline-block',
		width: 500,
		[theme.breakpoints.down('sm')]: {
			display: 'block',
			width: 'auto',
			marginLeft: 5,
		},
	},
	dialogBodyWrapper: {
		padding: '0px 40px',
		[theme.breakpoints.down('sm')]: {
			padding: '0px 8px',
		},
	},
	radioButtons: {
		display: 'inline-block',
		width: 500,
		marginLeft: '30%',
		[theme.breakpoints.down('sm')]: {
			display: 'block',
			width: 'auto',
			margin: 15,
		},
	},
	selectedRow: {
		'& .MuiTableCell-root': {
			backgroundColor: '#E5EDF5',
		},
	},
	unSelectedRow: {
		// '& .MuiTableCell-root:nth-child(2)': {
		// 	backgroundColor: '#F2F4F8',
		// },
	},
	confirmationDialogBody: {
		padding: '0 32px',
		height: '100%',
		[theme.breakpoints.down('xs')]: {
			padding: '0 16px',
		},
	},
	confirmationDialogTableWrapper: {
		paddingTop: '30px',
		marginBottom: '20px',
		'& .MuiTableCell-root': {
			padding: '0px !important',
			paddingLeft: '5px !important',
			textAlign: 'center',
			border: 'none',
		},
		'& .MuiTableCell-root:nth-child(1)': {
			borderRight: `1px solid ${borderColor} !important`,
		},
		'& .MuiTableBody-root': {
			'& .MuiTableCell-root': {
				padding: '10px 5px 5px 5px !important',
				border: `1px solid ${borderColor} !important`,
			},
			'& .MuiTableRow-root:hover .MuiTableCell-root': {
				backgroundColor: rowHoverColor,
			},
		},
	},
	tableHead: {
		'& .MuiTableCell-head': {
			color: whiteColor,
			backgroundColor: grayColor[2],
			padding: '10px 5px 5px 5px !important',
		},
	},
});

export default selectPlanDialogStyle;
